import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_8222_37004)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.33301 3.88342H8.33301V8.88342H3.33301V3.88342ZM11.6663 3.88342H16.6663V8.88342H11.6663V3.88342ZM3.33301 12.2168H8.33301V17.2168H3.33301V12.2168Z",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_8222_37004" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white",
      transform: "translate(0 0.550049)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }